let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Dc5Y")).then(() => parcelRequire('2UK0t'));